/**
 * Manual gallery: paginate + lightbox (Wix gallery has no runtime JS in Shopify).
 */
(function () {
  var root = document.getElementById('mwg-manual-viewer');
  if (!root) return;

  var pages = [];
  try {
    pages = JSON.parse(root.getAttribute('data-pages') || '[]');
  } catch (e) {
    pages = [];
  }
  if (!pages.length) return;

  var perPage = 2;
  var pageIndex = 0;
  var totalSpreads = Math.max(1, Math.ceil(pages.length / perPage));

  var grid = root.querySelector('[data-mwg-grid]');
  var counter = root.querySelector('[data-mwg-counter]');
  var prevBtn = root.querySelector('[data-mwg-prev]');
  var nextBtn = root.querySelector('[data-mwg-next]');
  var lightbox = document.getElementById('mwg-manual-lightbox');
  var lightboxImg = lightbox && lightbox.querySelector('img');
  var lightboxClose = lightbox && lightbox.querySelector('[data-mwg-close]');
  var lightboxPrev = lightbox && lightbox.querySelector('[data-mwg-lb-prev]');
  var lightboxNext = lightbox && lightbox.querySelector('[data-mwg-lb-next]');
  var lightboxIndex = 0;

  function render() {
    var start = pageIndex * perPage;
    var slice = pages.slice(start, start + perPage);
    grid.innerHTML = '';
    slice.forEach(function (src, i) {
      var absolute = start + i;
      var item = document.createElement('button');
      item.type = 'button';
      item.className = 'mwg-manual-viewer__item';
      item.setAttribute('aria-label', 'Open manual page ' + (absolute + 1));
      item.innerHTML =
        '<img src="' +
        src +
        '" alt="Manual page ' +
        (absolute + 1) +
        '" loading="' +
        (absolute < 2 ? 'eager' : 'lazy') +
        '" width="340" height="441">';
      item.addEventListener('click', function () {
        openLightbox(absolute);
      });
      grid.appendChild(item);
    });
    if (counter) {
      counter.textContent = pages.length <= perPage
        ? '1/' + pages.length
        : pageIndex + 1 + '/' + totalSpreads;
    }
    if (prevBtn) prevBtn.disabled = pageIndex <= 0;
    if (nextBtn) nextBtn.disabled = pageIndex >= totalSpreads - 1;
  }

  function openLightbox(index) {
    if (!lightbox || !lightboxImg) return;
    lightboxIndex = index;
    lightboxImg.src = pages[lightboxIndex];
    lightboxImg.alt = 'Manual page ' + (lightboxIndex + 1);
    lightbox.hidden = false;
    document.body.classList.add('mwg-manual-lightbox-open');
    lightboxClose && lightboxClose.focus();
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.hidden = true;
    document.body.classList.remove('mwg-manual-lightbox-open');
  }

  function stepLightbox(delta) {
    lightboxIndex = (lightboxIndex + delta + pages.length) % pages.length;
    lightboxImg.src = pages[lightboxIndex];
    lightboxImg.alt = 'Manual page ' + (lightboxIndex + 1);
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      if (pageIndex > 0) {
        pageIndex -= 1;
        render();
      }
    });
  }
  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      if (pageIndex < totalSpreads - 1) {
        pageIndex += 1;
        render();
      }
    });
  }
  if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
  if (lightboxPrev) lightboxPrev.addEventListener('click', function () { stepLightbox(-1); });
  if (lightboxNext) lightboxNext.addEventListener('click', function () { stepLightbox(1); });
  if (lightbox) {
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeLightbox();
    });
  }
  document.addEventListener('keydown', function (e) {
    if (lightbox && !lightbox.hidden) {
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') stepLightbox(-1);
      if (e.key === 'ArrowRight') stepLightbox(1);
    }
  });

  render();
})();
